import { IntegrationIconProps } from './types';

const AdobeXd = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="2" width="28" height="28" fill="#FF26BE" />
    <rect x="3" y="3" width="26" height="26" fill="#2E001F" />
    <path
      d="M16.5726 22.8066L13.1662 15.9972L16.4195 9.18041C16.4808 9.07732 16.444 9 16.346 9H14.3724C14.2543 9 14.2039 9.07987 14.1518 9.16752L11.8963 14.322L9.57959 9.15463C9.53055 9.03866 9.48152 9.01289 9.35894 9.01289H7.25058C7.17704 9.01289 7.10349 9.0902 7.17704 9.19329L10.4254 15.9972L7.03599 22.8195C6.9747 22.8968 6.98696 22.9999 7.10954 22.9999H9.13209C9.23016 22.9999 9.29145 22.9612 9.35274 22.8582L11.737 17.5178L14.1088 22.8453C14.1701 22.9741 14.2314 22.9999 14.3662 22.9999H16.4991C16.5972 22.9999 16.6339 22.9097 16.5726 22.8066Z"
      fill="#FF26BE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1194 12.5305C19.1039 12.5305 17.204 14.8758 17.204 17.8783C17.204 21.3833 19.0802 23.0128 21.7401 22.9999C22.7698 22.9999 23.8723 22.8652 24.9019 22.3498C24.9755 22.3111 25 22.2853 25 22.208C24.9387 21.7312 24.9387 21.2931 24.9387 20.9452V9.11566C24.9387 9.05123 24.9142 9.01257 24.8161 9.01257H22.8794C22.8181 9.01257 22.7568 9.06412 22.7568 9.14143V12.5563C22.5117 12.5305 22.3768 12.5305 22.1194 12.5305ZM22.0458 14.4505C22.34 14.4505 22.5852 14.5021 22.7568 14.5794V20.9581C22.5239 21.0612 22.2052 21.0998 21.911 21.0998C20.5259 21.0998 19.4227 20.1462 19.4227 17.7752C19.4227 15.7005 20.5013 14.4505 22.0458 14.4505Z"
      fill="#FF26BE"
    />
  </svg>
);
export default AdobeXd;
